import { ConfigInterface } from '../exports/Interfaces';
import BackendApiClient from './BackendApiClient';
import { DataWrappedResponse } from '../exports/Types';
import DomainResource from '../resources/DomainResource';
import StorefrontResource from '../resources/StorefrontResource';

export type GetStoreConfigParams =
  | {
      franchise_slug: string;
    }
  | { domain: string };

class ConfigManager {
  private subdomain = DomainResource.extractSubdomain();
  private domain = DomainResource.getHostname();

  public get = async (): Promise<DataWrappedResponse<ConfigInterface>> =>
    BackendApiClient.request({
      method: 'GET',
      url: '/store-config',
      params: this.getFranchiseParams(),
    });

  private getFranchiseParams = (): GetStoreConfigParams => {
    if (this.subdomain && !StorefrontResource.isStorefront()) {
      return { franchise_slug: this.subdomain };
    }
    return { domain: this.domain };
  };
}

export default new ConfigManager();
